import {
  DbUserType,
  useDeleteApiUsersTypesByUserTypeMutation,
  useGetApiUsersTypesQuery,
  usePatchApiUsersTypesByUserTypeMutation,
  usePostApiUsersTypesMutation,
} from '../../../../app/athenaApiGen';
import AdminCatalogPanel from '../AdminCatalogPanel';

// UserType uses the shared SimpleCatalog request shape: `{ name, description }`.
// The form field is named `userType` to match the response object; buildCreateArg
// maps it to `name` for the request body.
const AdminUserTypesPanel = () => (
  <AdminCatalogPanel<DbUserType>
    tableName="User Type"
    apiPath="/api/users/types"
    pkAccessor="userType"
    useList={() => useGetApiUsersTypesQuery()}
    useCreate={usePostApiUsersTypesMutation}
    useUpdate={usePatchApiUsersTypesByUserTypeMutation}
    useDelete={useDeleteApiUsersTypesByUserTypeMutation}
    buildCreateArg={(v) => ({
      handlersSimpleCatalogRequest: {
        name: (v.userType as string) ?? '',
        description: v.description as string | undefined,
      },
    })}
    buildUpdateArg={(row, v) => ({
      userType: row.userType as string,
      handlersSimpleCatalogUpdateRequest: {
        description: v.description as string | undefined,
      },
    })}
    buildDeleteArg={(row) => ({ userType: row.userType as string })}
    fields={[
      {
        name: 'userType',
        label: 'User Type',
        type: 'text',
        required: true,
        immutableOnEdit: true,
      },
      { name: 'description', label: 'Description', type: 'textarea' },
      { name: 'archived', label: 'Archived', type: 'boolean' },
    ]}
    fkConflictMessage="One or more users still have this type. Reassign them before deleting."
  />
);

export default AdminUserTypesPanel;
